var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function getNextPage(pageParam, total) {
    var hasMore = pageParam.offset + pageParam.limit < total;
    if (hasMore) {
        return {
            limit: pageParam.limit,
            offset: pageParam.offset + pageParam.limit,
        };
    }
    return undefined;
}
export function updateFirstMessage(messages) {
    var updatedMessages = __spreadArray([], messages, true);
    var firstMessageIndex = updatedMessages.findIndex(function (message) { var _a, _b; return message.type === 'autotext' && ((_b = (_a = message.content) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.includes('Hey! Please write your questions below')); });
    if (firstMessageIndex !== -1) {
        var originalMessage = updatedMessages[firstMessageIndex];
        updatedMessages[firstMessageIndex] = __assign(__assign({}, originalMessage), { content: __assign(__assign({}, originalMessage.content), { text: 'Hey 👋 Thanks for reaching out. Just a heads up - between 19th Dec and 5th Jan, my replies might be a little slower because of the holiday break. Do still drop your questions here anytime - I’ll get back to you as soon as I can! Can’t wait to chat with you soon 😊' }) });
    }
    return updatedMessages;
}
